// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"G5-z","colorTextValue":"H5-z","swatches":"I5-z","collapseLink":"J5-z","isCollapsed":"K5-z","dropdown":"L5-z","disabled":"M5-z"};